import ReactSpeedometer, { Transition } from "react-d3-speedometer";
import { MeterDataType } from "../../interfaces/MeterType";
import useAppStore from "../../store/AppStore";
import useHintStore from "../../store/hintStateStore";
import { getGeneralImage, generateStyleClasses } from "../../helpers/commonFunctions";

export default function Chart({ data }: { data: MeterDataType }) {
  const hint = data?.hint;
  const scoring = data?.scoring;
  const gradient = scoring?.gradient;
  const { isDeviceMobile } = useAppStore();
  const { setOpen } = useHintStore();

  const openModal = () => {
    setOpen(true, hint?.link);
  };

  return (
    <div className="vas-w-100">
      <div className="vas-d-flex vas-justify-content-center vas-align-items-end vas-w-100">
        <span
          className={`vas-d-block ${
            isDeviceMobile ? "vas-fs-5" : "vas-fs-4"
          } vas-mx-2 vas-mt-4 ${generateStyleClasses(scoring?.lowestText?.style)}`}
          style={{
            color: scoring?.lowestText?.textColor,
          }}
        >
          {scoring?.lowestText?.text}
        </span>
        <div
          className="vas-h-100 vas-d-flex vas-flex-column vas-align-self-center vas-align-items-center vas-justify-content-center"
          style={{
            width: `${!isDeviceMobile ? "350px" : "175px"}`,
            height: `${!isDeviceMobile ? "300px" : "180px"}`,
          }}
        >
          <div
            className="vas-w-100"
            style={{
              overflowY: "hidden",
              height: `${!isDeviceMobile ? "180px" : "95px"}`,
            }}
          >
            <ReactSpeedometer
              needleHeightRatio={0.7}
              segments={0}
              customSegmentStops={[0, 24, 25, 49, 50, 74, 75, 100]}
              segmentColors={[
                gradient[0],
                "#FFFFFF",
                gradient[1],
                "#FFFFFF",
                gradient[2],
                "#FFFFFF",
                gradient[3],
              ]}
              minValue={0}
              maxValue={100}
              value={scoring?.value >= 99 ? 99 : scoring?.value}
              fluidWidth={true}
              ringWidth={!isDeviceMobile ? 20 : 10}
              textColor={"transparent"}
              needleColor={"#323232"}
              needleTransition={Transition.easeBackOut}
              needleTransitionDuration={1500}
            />
          </div>
          <div
            className="vas-d-flex vas-flex-column vas-align-items-center vas-justify-content-center"
            style={{ marginTop: "-18px" }}
          >
            <img
              className="vas"
              src={
                "https://opensooqui-new.s3.amazonaws.com/os_web/desktop/addPost/bold_circle.png"
              }
              alt="chart_icon"
              width={!isDeviceMobile ? 26 : 18}
              height={!isDeviceMobile ? 26 : 18}
            />
          </div>
        </div>
        <span
          className={`vas-d-block ${
            isDeviceMobile ? "vas-fs-5" : "vas-fs-4"
          } vas-mx-2 vas-mt-4 ${generateStyleClasses(scoring?.highestText?.style)}`}
          style={{
            color: scoring?.highestText?.textColor,
          }}
        >
          {scoring?.highestText?.text}
        </span>
      </div>
      {
        <div
          className={`vas-d-flex vas-justify-content-center vas-align-items-center ${
            !isDeviceMobile ? "vas-fs-4" : "vas-fs-7"
          } ${generateStyleClasses(hint?.style)}`}
          style={{ color: hint?.textColor }}
          dir={"ltr"}
        >
          <span className="vas-mx-1 pointerCursor" onClick={openModal}>
            {hint?.text}
          </span>
          {hint.icon && (
            <img
              onClick={openModal}
              className="vas vas-fs-6 pointerCursor"
              src={getGeneralImage(hint.icon)}
              height={isDeviceMobile ? 32 : 46}
              width={isDeviceMobile ? 32 : 46}
              alt="chart_info"
            />
          )}
        </div>
      }
    </div>
  );
}
